module.exports = __webpack_public_path__ + "static/img/logo.e113b0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 16